<div>
  <h2 class="title is-3 mb-5 is-underlined has-text-link pointer">
    <a routerLink="/catalogue/metrics/{{ metric.slug }}">
      {{ metric.name | stripHtml }}</a
    >
    <a
      routerLink="/catalogue/metrics/{{ metric.slug }}"
      fragment=""
      *ngIf="metric.metricUseCases.length"
    >
      <span class="ml-3 tag is-small is-white-bis">
        {{ metric.metricUseCases.length }}
        related
        <some-element [ngPlural]="metric.metricUseCases.length">
          <ng-template ngPluralCase="=1">use case</ng-template>
          <ng-template ngPluralCase="other">use cases</ng-template>
        </some-element>
      </span>
    </a>
  </h2>

  <div>
    <div [innerHTML]="metric.content | truncate : [260]"></div>

    <ng-container *ngIf="metric.objectives.length">
      <div class="flex is-align-items-flex-start is-justify-content-flex-start">
        <p class="is-size-6 mt-0 mr-2 is-bold mb-4">Objectives:</p>
        <div class="tags">
          <a
            class="tag m-r-xs m-b-xs has-text-danger pointer objective-link"
            *ngFor="let objective of metric.objectives"
            [routerLink]="['/catalogue/metrics']"
            [queryParams]="{ objectiveIds: objective.id }"
            title="See metrics for &quot;{{ objective.name }}&quot;"
            >{{ objective.name | stripHtml }}</a
          >
        </div>
      </div>
    </ng-container>
  </div>
</div>
<hr class="is-large my-6 has-background-white-bis" />
